<template>
  <LoginLayout>
    <template #container>
      <LoginContainer
        :title="indexTitle"
        :switch-text="switchText"
        @switchTo="toLogin"
        :has-back="hasBack"
        @back="back"
        :businessType="businessType"
      >
        <template #form>
          <component ref="form" :is="componentName" />
        </template>
      </LoginContainer>
    </template>
  </LoginLayout>
</template>

<script>
import LoginLayout from '@/components/login/LoginLayout.vue'
import LoginContainer from '@/components/login/LoginContainer.vue'
import EmailStepAccount from './components/EmailStepAccount.vue'
import EmailStepDetail from './components/EmailStepDetail.vue'
import PhoneStepAccount from './components/PhoneStepAccount.vue'
import PhoneStepDetail from './components/PhoneStepDetail.vue'
import BaseMixin from '@/mixins/BaseMixin'
import { mapGetters } from 'vuex'
import { getUserRegional } from '@/utils/locale.js'
import { checkFromType } from '@/utils/checkLoginFromType'
import { param2Obj } from '@/utils/utils.js'
import { getBusinessType } from '@/constant'

export default {
  name: '',
  mixins: [BaseMixin],
  data() {
    return {}
  },

  components: {
    LoginLayout,
    LoginContainer,
    EmailStepAccount,
    EmailStepDetail,
    PhoneStepAccount,
    PhoneStepDetail,
  },

  computed: {
    hasBack() {
      return getBusinessType().id === 'njcb' ? false : !this.isIndex && !this.fromGuest
    },
    ...mapGetters(['eventData', 'regional']),
    componentName() {
      const _type = this.type
      const _step = this.step
      if (_type === 'email') {
        return _step === 'account' ? 'EmailStepAccount' : 'EmailStepDetail'
      } else if (_type === 'phone') {
        return _step === 'account' ? 'PhoneStepAccount' : 'PhoneStepDetail'
      }
      return 'PhoneStepAccount'
    },
    switchText() {
      return getBusinessType().id === 'njcb' ? '' : this.isMobile
        ? this.$t('login.loginPage.alreadyRegistered')
        : this.$t('login.loginPage.alreadyRegisteredBefore')
    },
    indexTitle() {
      // 如果有一万个南京银行要求不同的标题
      return this.$t(`login.register.${getBusinessType().sloganFromLocal}`)
    },
    businessType() {
      return getBusinessType().id
    },
  },

  async beforeRouteEnter(to, from, next) {
    // 获取用户地域，国内用户默认手机号码注册
    const { type } = await getUserRegional()
    const toType = checkFromType(to) === 'guest' ? 'email' : type

    // 判断是否需要跳转
    if (toType !== to.params.type) {
      next({
        name: to.name,
        params: {
          ...to.params,
          type: toType,
        },
        query: {
          ...to.query,
        },
      })
    } else {
      next()
    }
  },

  methods: {
    back() {
      if (!this.hasBanner) {
        // 平台
        this.$refs['form'].back()
      } else {
        // TODO: 活动urlback
        const { redirect_url } = param2Obj(window.location.href)
        window.location.href = redirect_url
      }
    },
    toLogin() {
      const toStep = this.fromGuest ? 'detail' : 'account'
      this.$router.push({
        path: '/login/' + this.type + '/' + toStep,
        query: { ...this.$route.query },
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
